export function formatPhoneNumber(phone: string) {
    const digits = phone.replace(/\D/g, '');
    if (digits.length === 11) {
        const formattedNumber = `+7 (${digits.substring(1, 4)}) ${digits.substring(4, 7)}-${digits.substring(7, 9)}-${digits.substring(9, 11)}`;
        return formattedNumber;
    }
    return phone;
}
